import { useParams } from "react-router-dom";
import house1 from '../../assets/images/house-1.jpg';
import house2 from '../../assets/images/house-2.jpg';
import room1 from '../../assets/images/room-1.jpg';
import room2 from '../../assets/images/room-2.jpg';
import "../../assets/styles/home.css";
import "../../assets/styles/listingPage.css";

const ListingPage = () => {
  const { slug } = useParams(); 
  const formatSlugTitle = (slug) => {
    return slug
      .split('-')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  const pageTitle = formatSlugTitle(slug);

  return (
    <div className="listing-container">
      {/* Sidebar */}
      <aside className="sidebar">
        <h1 className="sidebar-title">Community</h1>
        <ul className="cus-ul">
          <li> <span className="cus-label"> <a href="/">musicians</a> </span> 
          <span className="count">130</span>  <input type="checkbox" />
          </li>
          <li> <span className="cus-label"> <a href="/">pets</a> </span> 
          <span className="count">107</span>  <input type="checkbox" />
          </li>
          <li> <span className="cus-label"> <a href="/">general community
          </a> </span> 
          <span className="count">66</span>  <input type="checkbox" />
          </li>
          <li> <span className="cus-label"> <a href="/">artists</a> </span> 
          <span className="count">14</span>  <input type="checkbox" />
          </li>
          <li> <span className="cus-label"> <a href="/">lost & found</a> </span> 
          <span className="count">12</span>  <input type="checkbox" />
          </li>
        </ul>
        <div className="for-btn-flex">
        <button className="cus-btn">
          reset
          </button>
          <button className="cus-btn">
          cancel
          </button>
        </div>
       
      </aside>
      
      {/* Listings */}
      <main className="listings">
        <div className="location-title">
          <h3>{pageTitle}</h3>
        </div>
        <div className="card-grid">
          {[room1, room2, house1, house2 , room1 , room2].map((img, index) => (
            <div className="cus-card" key={index}>
              <img src={img} className="cus-card-img-top" alt={`Image ${index + 1}`} />
              <div className="cus-card-body">
                <h5 className="cus-card-title">Image {index + 1}</h5>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default ListingPage;